import { titleDesc } from "constants/architectsTranslation";

function TitleDesc({ desc, title }: titleDesc) {
  return (
    <span>
      <p className="fw-bold mb-0 fs-18" style={{ color: "var(--dark-gray)" }}>
        {title + ": "}
      </p>
      <p className="fs-16 ps-3">{desc}</p>
    </span>
  );
}

export default TitleDesc;
